export const paths = {
  login: '/auth/login',
  register: '/auth/register',
  resetPass: '/auth/reset-password',
  forgotPass: '/auth/forgot-password',
  app: '/app',
  profile: '/app/profile',
  secureScore: '/app/secure-score-summary',
  twoFaAuthentication: '/app/two-factor-authentication',
  home: '/user',
  addUser: '/user/add-user',
  admin: '/admin',
  addAdmin: '/admin/add-admin',
  threats: '/threats',
  insuranceCompanies: '/insurance-companies',
  addInsuranceCompanies: '/insurance-companies/add-insurance-company',
  insuranceCompanyDetails: '/insurance-companies/details',
  insuranceCompanyAdmin: '/insurance-companies/add-admin',
  incidents: '/incidents',
  policyParameters: '/policy-parameters',
  addPolicyParameter: '/policy-parameters/add-policy-parameter',
  resendVerificationLink: '/auth/resend-verification-link',
  Blogs: '/Blog/add-blog',
  editBlogs: '/Blog/edit-blog',
  // Reinsurer admin management
  reinsurers: '/reinsurers',
  reinsurerUsers: '/reinsurer-users',
  addReinsurerUser: '/reinsurer-users/add',
  editReinsurerUser: '/reinsurer-users/edit',
  // Reinsurer-viewer portal
  reinsurerPortal: '/reinsurer-portal',
}
